import { render, staticRenderFns } from "./splitOkrWorkDetails.vue?vue&type=template&id=25578880&scoped=true&"
import script from "./splitOkrWorkDetails.vue?vue&type=script&lang=js&"
export * from "./splitOkrWorkDetails.vue?vue&type=script&lang=js&"
import style0 from "./splitOkrWorkDetails.vue?vue&type=style&index=0&id=25578880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25578880",
  null
  
)

component.options.__file = "splitOkrWorkDetails.vue"
export default component.exports